import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { UserService } from '../../../services/user/user-svc.ng';

@Component({
    selector: 'user-info',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'block relative',
    },
    template: `<div>Welcome, {{ user()?.FirstName }} {{ user()?.LastName }}</div>`,
})
export class UserInfo {
    // #region Injects

    protected readonly userSvc = inject(UserService);

    // #endregion

    // #region Properties

    protected readonly user = computed(() => this.userSvc.user());

    // #endregion
}
